import {
  ADD_COMP_DISCOUNT,
  ADD_COMP_DISCOUNT_FULFILLED,
  ADD_COMP_DISCOUNT_REJECTED,
  CLEAR_COMP_DISCOUNTS,
  CLEAR_COMP_DISCOUNTS_FULFILLED,
  CLEAR_COMP_DISCOUNTS_REJECTED,
  FETCH_COMP_DISCOUNTS,
  FETCH_COMP_DISCOUNTS_FULFILLED,
  FETCH_COMP_DISCOUNTS_REJECTED,
  REMOVE_COMP_DISCOUNT,
  REMOVE_COMP_DISCOUNT_FULFILLED,
  REMOVE_COMP_DISCOUNT_REJECTED,
  REMOVE_COMP_DISCOUNTS,
  REMOVE_COMP_DISCOUNTS_FULFILLED,
  REMOVE_COMP_DISCOUNTS_REJECTED,
  SUBMIT_COMP_DISCOUNTS,
  SUBMIT_COMP_DISCOUNTS_FULFILLED,
  SUBMIT_COMP_DISCOUNTS_REJECTED,
  RESET_COMP_DISCOUNTS,
  RESET_REMOVE_COMP_DISCOUNTS,
} from './types';

const initialState = {
  availableCompDiscounts: [],
  appliedCompDiscounts: [],
  compDiscountsNotApplied: [],
  unavailableCompDiscounts: [],
  updatedCompDiscounts: [],
  fetchCompDiscountsState: {
    success: undefined,
    isPending: false,
    error: undefined,
  },
  addCompDiscountState: {
    isPending: false,
    error: undefined,
  },
  removeCompDiscountState: {
    isPending: false,
    error: undefined,
  },
  removeCompDiscountsState: {
    isPending: false,
    success: undefined,
    error: undefined,
  },
  clearCompDiscountsState: {
    isPending: false,
    error: undefined,
  },
  submitCompDiscountsState: {
    isPending: false,
    success: undefined,
    receiptText: undefined,
    error: undefined,
  },
};

export function compDiscountsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_COMP_DISCOUNT: {
      return {
        ...state,
        addCompDiscountState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case ADD_COMP_DISCOUNT_FULFILLED: {
      return {
        ...state,
        addCompDiscountState: {
          ...state.addCompDiscountState,
          isPending: false,
        },
      };
    }

    case ADD_COMP_DISCOUNT_REJECTED: {
      return {
        ...state,
        addCompDiscountState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case CLEAR_COMP_DISCOUNTS: {
      return {
        ...state,
        clearCompDiscountsState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case CLEAR_COMP_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        addCompDiscountState: {
          isPending: false,
          error: undefined,
        },
        removeCompDiscountState: {
          isPending: false,
          error: undefined,
        },
        clearCompDiscountsState: {
          isPending: false,
        },
      };
    }

    case CLEAR_COMP_DISCOUNTS_REJECTED: {
      return {
        ...state,
        clearCompDiscountsState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case FETCH_COMP_DISCOUNTS: {
      return {
        ...state,
        fetchCompDiscountsState: {
          success: undefined,
          isPending: true,
          error: undefined,
        },
      };
    }

    case FETCH_COMP_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        fetchCompDiscountsState: {
          ...state.fetchCompDiscountsState,
          success: true,
          isPending: false,
        },
        availableCompDiscounts: action.payload.availableCompDiscounts,
        appliedCompDiscounts: action.payload.appliedCompDiscounts,
        compDiscountsNotApplied: action.payload.compDiscountsNotApplied,
        unavailableCompDiscounts: action.payload.unavailableCompDiscounts,
        updatedCompDiscounts: action.payload.updatedCompDiscounts,
      };
    }

    case FETCH_COMP_DISCOUNTS_REJECTED: {
      return {
        ...state,
        fetchCompDiscountsState: {
          success: false,
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case REMOVE_COMP_DISCOUNT: {
      return {
        ...state,
        removeCompDiscountState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case REMOVE_COMP_DISCOUNT_FULFILLED: {
      return {
        ...state,
        removeCompDiscountState: {
          ...state.removeCompDiscountState,
          isPending: false,
        },
      };
    }

    case REMOVE_COMP_DISCOUNT_REJECTED: {
      return {
        ...state,
        removeCompDiscountState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case REMOVE_COMP_DISCOUNTS: {
      return {
        ...state,
        removeCompDiscountsState: {
          ...state.removeCompDiscountState,
          isPending: true,
          success: undefined,
          error: undefined,
        },
      };
    }

    case REMOVE_COMP_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        removeCompDiscountsState: {
          ...state.removeCompDiscountState,
          success: true,
          isPending: false,
        },
      };
    }

    case REMOVE_COMP_DISCOUNTS_REJECTED: {
      return {
        ...state,
        removeCompDiscountsState: {
          ...state.removeCompDiscountState,
          isPending: false,
          success: false,
          error: action.payload.error,
        },
      };
    }

    case RESET_REMOVE_COMP_DISCOUNTS: {
      return {
        ...state,
        removeCompDiscountsState: {
          ...initialState.removeCompDiscountsState,
        },
      };
    }

    case RESET_COMP_DISCOUNTS: {
      return {
        ...initialState,
      };
    }

    case SUBMIT_COMP_DISCOUNTS: {
      return {
        ...state,
        submitCompDiscountsState: {
          isPending: true,
          success: undefined,
          receiptText: undefined,
          error: undefined,
        },
      };
    }

    case SUBMIT_COMP_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        submitCompDiscountsState: {
          isPending: false,
          success: true,
          receiptText: action.payload.receiptText, // TODO (keithwong) hook up receipt logic
          error: undefined,
        },
      };
    }

    case SUBMIT_COMP_DISCOUNTS_REJECTED: {
      return {
        ...state,
        submitCompDiscountsState: {
          isPending: false,
          success: false,
          receiptText: undefined,
          error: action.payload.error,
        },
      };
    }

    default:
      return state;
  }
}
